export default {
  name: 'silent_notification',
  background (payload, context) {
    if (payload.refresh) {
      let store = this.$store || this
      if (store) {
        Promise.all([
          store.dispatch('notifications/clearNotifications'),
          store.dispatch('notifications/clearPage')
        ]).then(() => {
          store.dispatch('notifications/getNotifications')
        })
      } else {
        console.debug('store not found')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/SilentNotification.js